module.exports = __webpack_public_path__ + "img/Vector@2x.ea8dd291.png";